import script from "./DevicesView.vue?vue&type=script&setup=true&lang=js"
export * from "./DevicesView.vue?vue&type=script&setup=true&lang=js"

import "./DevicesView.vue?vue&type=style&index=0&id=48ae1ac0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48ae1ac0"]])

export default __exports__